import { FormInputValue } from '@src/domains/orders/core/form-inputs/types';

export const collectFormInputValues = (valuesByHash: Record<string, FormInputValue>): FormInputValue[] =>
  Object.values(valuesByHash).filter((input) => input.value !== '');
